export enum LocalKey {
  Staff = 'staff',
  Token = 'token',
  LastSync = 'lastsync'
}
